<template>
    <div class="animated fadeIn">
        <b-card header-tag="header">
            <div slot="header">
                <i class="fa fa-money"></i> Cobrança de Aluguel
                <a href="javascript:window.history.back();" class="btn mr-2 btn-sm btn-primary float-right">
                <i class="fa fa-angle-left"></i>
                  Voltar
                </a>
            </div>
            <b-card-body>
                <h4>{{model.sellerName}}</h4>
                <hr class="mb-5" />
                <form>
                    <div class="form-row justify-content-start">
                        <div class="col-sm-4">
                            <div class="form-group">
                                <label>Seller</label>
                                <input disabled type="text" :value="model.sellerName" class="form-control-plaintext" />                                
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group">
                                <label>Documento</label>
                                <input disabled type="text" :value="model.sellerDocument" class="form-control-plaintext" />                                
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group">
                                <label>Contrato</label>
                                <input disabled type="text" :value="model.contractName"  class="form-control-plaintext" />                                
                            </div>
                        </div>                        
                    </div>
                    <hr class="mt-3 mb-5" />
                    <div class="form-row justify-content-start">
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label>Código</label>
                                <input disabled type="text" :value="model.id" class="form-control-plaintext" />                                
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label>Data Cobrança</label>
                                <input disabled type="text" :value="chargeDate" class="form-control-plaintext" />                                
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label>Valor</label>
                                <input disabled type="text" :value="amount"  class="form-control-plaintext" />                                
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label>Status</label>
                                <input disabled type="text" :value="status"  class="form-control-plaintext" />                                
                            </div>
                        </div>
                    </div>                                        
                </form>
            </b-card-body>
        </b-card>
        <b-card>
            <h4>Detalhe da cobrança</h4>
            <hr class="mb-5" />
            <b-card>
            <b-table
                :items="model.items"
                :fields="fields"
                :striped="true"
                responsive
            >              
            <template slot="startDate" slot-scope="data">{{formatDateTimeFields(data.value)}}</template>
            <template slot="endDate" slot-scope="data">{{formatDateTimeFields(data.value)}}</template>
            <template slot="deviceModelTax" slot-scope="data">{{formatDecimalFields(data.value)}}</template>          
            <template slot="amount" slot-scope="data">{{formatDecimalFields(data.value)}}</template>          
            </b-table>
        </b-card>
        </b-card>
    </div>    
</template>
<script>
import cTable from "../../components/base/Table.vue";
import editPage from '../../mixins/editPage'
import domainService from "../../services/Devices/deviceRentalChargeService";
import moment from 'moment';
export default {
    props: {
        id: String
    },
    components: {
        cTable    
    },
    mixins: [editPage],
    data() {
        return {
            actionUri: '',
            model: {
                sellerName: '',
                sellerDocument: '',
                sellerId: '',
                status: '',
                amount: 0,
                contractId: '',
                contractName: '',
                items: []

            },
            fields: [
                { key: "serialNumber", label: "Serial Number", sortable: false },
                { key: "deviceModelName", label: "Modelo", sortable: false },                
                { key: "deviceModelTax", label: "Taxa", sortable: false },
                { key: "amount", label: "Valor", sortable: false },                
                { key: "chargeDays", label: "Dias de cobrança", sortable: false },
                { key: "startDate", label: "Data inicial da cobrança", sortable: false },
                { key: "endDate", label: "Data final da cobrança", sortable: false }                
            ]
        }
    },
    computed: {
        amount() {
            return this.model.amount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        },
        status() {
            switch(this.model.status.toUpperCase()) {                
                case 'CREATED':
                return 'Criado';
                case 'PROCESSING':
                return 'Processando';
                case 'DONE':
                return 'Finalizado';
            }
        },
        chargeDate() {
            return moment(this.model.chargeDate).format('DD/MM/YYYY');
        }
    },
    created(){
        this.fetchData()
    },
    methods:{
        fetchData() {
            const self = this;
            self.showLoading();
            domainService.find(this.id).then(
                response => {
                    self.model = response.data;                    
                    self.hideLoading();
                },
                error => {
                    self.showError(error.response.data.result.errors[0].description);
                    self.hideLoading();
                }
            );
        },
        formatDateTimeFields(value) {
            return value == null || value == '' ? '' : moment(value).format('DD/MM/YYYY');
        },
        formatDecimalFields(value) {
            return value == null || value == '' ? 'R$ 0,00' : value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        }
    }
}
</script>